<template>
  <div class="markdown-body">
    <div>
      <!--<h2 class="text-success text-center">Preview</h2>-->
      <div v-html="previewText" align="left"></div>
    </div>
  </div>
</template>

<script>
import util from "../libs/util.js";
let marked = require("marked");
//import Prism from 'prismjs';
//import marked from 'marked';
//import VueMarkdown from 'vue-markdown'
import hljs from "highlight.js";
//import 'highlight.js/styles/googlecode.css'
//import 'highlight.js/styles/solarized-dark.css';
import 'highlight.js/styles/paraiso-light.css'
//import { log } from 'util';
//import 'prismjs';
//import 'prism-solarized-dark/prism-solarizeddark.css'
//import "../../node_modules/prismjs/themes/prism.css";
//import "../../node_modules/prismjs/themes/prism-okaidia.css";

//import mdit from 'markdown-it';
/*
    marked.setOptions({
    renderer: new marked.Renderer(),
    gfm: true,
    tables: true,
    breaks: false,
    pedantic: false,
    sanitize: false,
    smartLists: true,
    smartypants: false,
    highlight: function (code, lang) {
          if (lang && hljs.getLanguage(lang)) {    
            return hljs.highlight(lang, code, true).value;
          } else {
            return hljs.highlightAuto(code).value;
          }
      }
  });
*/
// Actual default values

export default {
  components: {
    //VueMarkdown  // 声明组件
  },
  data() {
    return {
      msg: "",
      context: "",
      author: ""
    };
  },
  computed: {
    previewText() {
      marked.setOptions({
        renderer: new marked.Renderer(),
        gfm: true,
        tables: true,
        breaks: true,
        pedantic: false,
        sanitize: true,
        smartLists: true,
        smartypants: false,
        highlight: function (code, lang) {
          if (lang && hljs.getLanguage(lang)) {    
            return hljs.highlight(lang, code, true).value;
          } else {
            return hljs.highlightAuto(code).value;
          }
      }
      });

      return marked(this.msg);
    }
  },
  methods: {
    query_archives() {
      util.ajax
        .get("/view_archive/" + this.$route.params.view_name)
        .then(response => {
          this.context = response.data.context;
 
          this.msg = response.data.context;
          this.author = response.data.author;
          console.log(this.context);
          this.info = response.data;
          document.title = this.$route.params.view_name + ' - cntomy.org';
        })
        .catch(error => {
          this.$Notice.error({
            title: "query failed",
            desc: error.response ? error.response.data.error : error,
            duration: 2
          });
          //console.log(this.$route.params.view_name);
        });

    }
  },
  mounted() {
    this.query_archives();
    //Prism.highlightAll();
  }
};
</script>

<style >

</style>